import { useParams } from 'react-router-dom';
import { currentCountryMarketInfo } from '../utils/countries.ts';
import { IS_DEVELOPMENT } from '../utils/envConstants.ts';
import { gatekeeper } from '../utils/gatekeeper.ts';

const useMarketInfo = () => {
  const { market } = useParams<{ market: string }>();

  const marketSlug = !IS_DEVELOPMENT
    ? gatekeeper?.localisation.marketSlug
    : market!;

  const oldData = JSON.parse(localStorage.getItem(`data_${marketSlug}`) || '{}');

  const countryCode = oldData?.countryOfResidence; 

  return currentCountryMarketInfo(marketSlug, countryCode);
};

export default useMarketInfo;
